/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
/**
 * This hook is to handle if 'key' changes, but not on initial render.
 */
import { useEffect, useRef } from 'react';
export var useDidMountEffect = function useDidMountEffect(func, deps) {
  var didMount = useRef(false);
  useEffect(function () {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
};